import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./theme";
import { BrowserRouter } from "react-router-dom";

const element = document.getElementById("root");
if (!element) {
  throw new Error("Could not find root element");
}

const root = ReactDOM.createRoot(element);
root.render(
  <React.StrictMode>
    <ChakraProvider resetCSS={true} theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>
);
